import { atomWithReset } from 'jotai/utils'

interface CpsCodeModalAtomState {
  onPinCodeInput: ((pincode: string | null) => void) | null
}

export const cpsCodeModalAtom = atomWithReset<CpsCodeModalAtomState>({
  onPinCodeInput: null,
})
